import { ChannelType } from 'api/ChannelsAPI';
import { TemplateAndContent } from 'modules/graphql';
import { GraphQLTemplateAndContent } from 'modules/campaigns/editor/types';
import { useFrequencyManagementSettings } from './useFrequencyManagementSettings';

type State = {
  isTemplateFrequencyManagementEligible: boolean;
  isTemplateFrequencyManaged: boolean;
};

export const useTemplateAndContentFrequencyManagementSettings = (
  templateAndContent: TemplateAndContent | GraphQLTemplateAndContent,
): State => {
  const messageType = templateAndContent?.messageType;
  const messageTypeId = messageType?.id;
  const messageChannel = messageType?.messageChannel;
  const messageMedium = messageChannel?.messageMedium;

  const skip = !messageChannel || !messageMedium || !messageTypeId;

  const {
    isFrequencyManagementEnabled,
    isMessageChannelFrequencyManagementEligible,
    isMessageMediumFrequencyManaged,
    isMessageTypeFrequencyManaged,
  } = useFrequencyManagementSettings({ skip });

  if (skip || !isFrequencyManagementEnabled)
    return {
      isTemplateFrequencyManagementEligible: false,
      isTemplateFrequencyManaged: false,
    };

  return {
    isTemplateFrequencyManagementEligible: isMessageChannelFrequencyManagementEligible(
      messageChannel.channelType as ChannelType,
      messageMedium,
    ),
    isTemplateFrequencyManaged:
      isMessageMediumFrequencyManaged(messageMedium) ||
      isMessageTypeFrequencyManaged(messageTypeId, messageMedium),
  };
};
